import api from './api';

export const activityService = {
  // Get current user's activity
  getMyActivity: async (params = {}) => {
    const response = await api.get('/activity/me', { params });
    return response.data;
  },

  // Get activity for a project
  getProjectActivity: async (projectId, params = {}) => {
    const response = await api.get(`/activity/project/${projectId}`, { params });
    return response.data;
  },

  // Get activity for a specific entity
  getEntityActivity: async (entity, entityId, params = {}) => {
    const response = await api.get(`/activity/${entity}/${entityId}`, { params });
    return response.data;
  },
};

export default activityService;
